/*----------------------------------------------- PURCHASE SECTION -----------------------------------------------*/
// PRODUCT SELECTION
function selectProduct(prod_id, var0_id, var1_id, var0_price, var1_price, var0_title, var1_title) {
  var purchaseProduct = var0_price/100;
  var purchaseProductResults = var1_price/100;
  console.log(prod_id);
  console.log(var0_id);
  console.log(var1_id);
  console.log(var0_title);
  console.log(var1_title);
  console.log(var0_price);
  console.log(var1_price);
  // IF CLICK ONE OF THE CHECK-BOXES, REMOVE PREVIOUS APPENDED PRICE, AND THEN PREPEND ONE OF THE VARIABLES BELOW
  $('#purchase .cost h2').remove();

  if ($('#purchase .results .input').is(':checked')) {
    $('#purchase .cost').append( "<h2 class = 'h2-3tandai'>$" + purchaseProductResults + "</h2>" );

    $('#purchase .results .hidden-input :hidden').remove();
    console.log(var1_title);
    $('#purchase .results .hidden-input').append("<input type='hidden' name='id' data-productid=" + prod_id + " class='product-select' value=" + var1_id + " data-variant-title=" + var1_title + " />");
  }

  if (!$('#purchase .results .input').is(':checked')) {
    $('#purchase .cost').append( "<h2 class = 'h2-3tandai'>$" + purchaseProduct + "</h2>" );

    $('#purchase .results .hidden-input :hidden').remove();
    $('#purchase .results .hidden-input').append("<input type='hidden' name='id' data-productid=" + prod_id + " class='product-select' value=" + var0_id + " data-variant-title=" + var0_title + " />");
  }

};


$(document).ready(function() {
  // RESULTS
  $( "#purchase .results .input" ).on('click tap', function () {

    if ($('#purchase .results .input').is(':checked')) {
      $(this).closest('.item').find('.prices h4').css( { 'display' : 'block' });
      $(this).closest('.item').find('.prices h3:first-of-type').css( { 'display' : 'none' });
      $(this).closest('.item').find('.prices h3:last-of-type').css( { 'display' : 'block' });
    };

    if (!$('#purchase .results .input').is(':checked')) {
      $(this).closest('.item').find('.prices h4').css( { 'display' : 'none' });
      $(this).closest('.item').find('.prices h3:first-of-type').css( { 'display' : 'block' });
      $(this).closest('.item').find('.prices h3:last-of-type').css( { 'display' : 'none' });
    };

  });

});

$(document).ready(function() {

  $('#purchase .item-description-button').on('click tap', function () {
    $('#purchase .item-description-detail').slideToggle();

    $('#purchase .item-description-button span:first-of-type').toggleClass('item-description-button-span-first-of-type-active');
    $('#purchase .item-description-button span:last-of-type').toggleClass('item-description-button-span-last-of-type-active');  

    $(this).find('h5').text(function(i, text){
        return text === "Hide details" ? "See details" : "Hide details";
    })
  })


  $( "#purchase .results .input" ).on('click tap', function () {
    $('#purchase .results h5:nth-of-type(2)').slideToggle();
  })

});
/*----------------------------------------------- PURCHASE SECTION -----------------------------------------------*/




















// ----------------------------------------------- CORE SECTION -----------------------------------------------*/
// // ON LOAD - DESKTOP
// $(document).ready(function() {

//   if(window.matchMedia("(min-width: 769px)").matches) {
//     // FIRST TILE
//     // MAKE BACKGROUND COLOR ORANGE
//     $("#core-features .description-wrap-sm:first-of-type .tile-container:first-of-type").addClass("active-button");
//     // MAKE FONT COLOR WHITE
//     $("#core-features .description-wrap-sm:first-of-type .tile-container:first-of-type h5").addClass("active-h5");
//     // HIDE GREY ICON
//     $("#core-features .description-wrap-sm:first-of-type .tile-container:first-of-type img:first-of-type").hide();
//     // SHOW WHITE ICON
//     $("#core-features .description-wrap-sm:first-of-type .tile-container:first-of-type img:last-of-type").show();
//     // DETERMINE PADDING-BOTTOM
//     var paddingBottom = $('#core-features .description-wrap-sm:first-of-type .tile-container:first-of-type .description').outerHeight(true);
//     $('.description-wrap-lg').css( {'padding-bottom' : paddingBottom });


//     // SECOND TILE
//     // SHOW GREY ICON
//     $("#core-features .description-wrap-sm:first-of-type .tile-container:last-of-type img:first-of-type").show();
//     // HIDE WHITE ICON
//     $("#core-features .description-wrap-sm:first-of-type .tile-container:last-of-type img:last-of-type").hide();
//     // HIDE DESCRIPTION TEXT
//     $("#core-features .description-wrap-sm:first-of-type .tile-container:last-of-type .description").hide();


//     // TILES 3-8, 
//     // SHOW GREY ICON
//     $("#core-features .description-wrap-sm:nth-of-type(n+2) .tile-container img:first-of-type").show();
//     // HIDE WHITE ICON
//     $("#core-features .description-wrap-sm:nth-of-type(n+2) .tile-container img:last-of-type").hide();
//     // HIDE DESCRIPTION TEXT
//     $("#core-features .description-wrap-sm:nth-of-type(n+2) .tile-container .description").hide();

//   }

// });



// // ON LOAD - MOBILE
// $(document).ready(function() {

//   if(window.matchMedia("(max-width: 768px)").matches) {

//     // SHOW GREY ICON
//     $("#core-features .description-wrap-sm .tile-container img:first-of-type").show();
//     // HIDE WHITE ICON
//     $("#core-features .description-wrap-sm .tile-container img:last-of-type").hide();
//     // HIDE THE DESCRIPTION TEXT
//     $("#core-features .description-wrap-sm .tile-container .description").hide();

//   }

// });


// $(document).ready(function() {
//   // ON CLICK OF TILE
//   $("#core-features .tile-container").click(function(){

//     // IF THIS ISN'T ALREADY ACTIVE
//     if (!$(this).hasClass("active-button")) {

//       // REMOVE THE CLASS FROM ANYTHING THAT IS ACTIVE
//       $("#core-features .tile-container.active-button").removeClass("active-button");
//       $("#core-features .tile-container h5.active-h5").removeClass("active-h5");
//       $('#core-features img:last-of-type').hide()
//       $('#core-features img:first-of-type').show()
//       $('#core-features .description').hide()


//       // AND MAKE THIS ACTIVE
//       $(this).addClass("active-button");
//       $(this).find('h5').addClass("active-h5");
//       $(this).find('img:last-of-type').show();
//       $(this).find('img:first-of-type').hide();
//       $(this).find('.description').show();
//     }
//   });



//   // ON CLICK, DETERMINE PADDING-BOTTOM NEEDED FOR $THIS TILE'S DESCRIPTION
//   $("#core-features .tile-container").on('click tap', function () {
//     if(window.matchMedia("(min-width: 769px)").matches) {
//       var paddingBottom = 0;
//       paddingBottom = paddingBottom + $(this).find('.description').outerHeight(true);

//       $(this).closest('.description-wrap-lg').css( {
//         'padding-bottom' : paddingBottom });
//     }
//   });



//   // FOR MOBILE, ON CLICK, DETERMINE HEIGHT NEEDED FOR SPACE BENEATH TILE
//   $("#core-features .tile-container").on('click tap', function () {
//     if(window.matchMedia("(max-width: 381px)").matches) {
//       var height = 152;
//       height = height + 32 + $(this).find('.description').outerHeight(true);

//       $('.description-wrap-sm').height(152);  
//       $(this).closest('.description-wrap-sm').height(height);

//     }
//     if(window.matchMedia("(min-width: 382px) and (max-width: 768px)").matches) {
//       var height = 183;
//       height = height + 32 + $(this).find('.description').outerHeight(true);

//       $('.description-wrap-sm').height(183);  
//       $(this).closest('.description-wrap-sm').height(height);

//     }
//   });



//   // ON WINDOW RESIZE
//   $(window).resize(function() {

//     if ($(window).width() >= 769) {
//       $(window).resize(function() {
//         if(window.matchMedia("(max-width: 768px)").matches) {

//           $('.description-wrap-lg').css({'padding-bottom' : '0px'});
//           height = 183;
//           height = height + 32 + $('.tile-container.active-button').find('.description').outerHeight(true);
//           $('.tile-container.active-button').closest('.description-wrap-sm').css({'height' : height});

//         }

//       });
//     }

//     if ($(window).width() >= 382) {
//       $(window).resize(function() {
//         if(window.matchMedia("(max-width: 381px)").matches) {
//           $('.description-wrap-sm').css({'height' : '152px'});
//           $('.description-wrap-lg').css({'padding-bottom' : '0px'});
//           height = 183;
//           height = height + 32 + $('.tile-container.active-button').find('.description').outerHeight(true);
//           $('.tile-container.active-button').closest('.description-wrap-sm').css({'height' : height});

//         }

//       });
//     }

//     if ($(window).width() <= 381) {
//       $(window).resize(function() {
//         if(window.matchMedia("(min-width: 382px)").matches) {
//           $('.description-wrap-sm').css({'height' : '183px'});
//           $('.description-wrap-lg').css({'padding-bottom' : '0px'});
//           height = 183;
//           height = height + 32 + $('.tile-container.active-button').find('.description').outerHeight(true);
//           $('.tile-container.active-button').closest('.description-wrap-sm').css({'height' : height});

//         }

//       });
//     }


//     else if ($(window).width() <= 768) {
//       $(window).resize(function() {
//         if(window.matchMedia("(min-width: 769px)").matches) {

//           $('.description-wrap-sm').css( {'height' : '183px' });
//           paddingBottom = 0;
//           paddingBottom = paddingBottom + $('.tile-container.active-button').find('.description').outerHeight(true);
//           $('.tile-container.active-button').closest('.description-wrap-lg').css( {
//             'padding-bottom' : paddingBottom });

//         }
//       });
//     }

//   });



//   // ANIMATION
//   $( "#core-features .tile-container" ).on('click tap', function () {
//     $(this).find('.h4 span').addClass("animated pulse");
//   });
//   /*----------------------------------------------- CORE SECTION (END) -----------------------------------------------
// });


/*----------------------------------------------- GENERAL ANIMATE.CSS & WAYPOINT ANIMATIONS -----------------------------------------------*/
$(document).ready(function() {

  $('#report .element-to-slideInLeft').waypoint(function() {

      $(this.element).addClass('slideInLeft');

  }, 

  { offset: '125%' });


  $('#report .element-to-slideInRight').waypoint(function() {

      $(this.element).addClass('slideInRight');

  }, 

  { offset: '125%' });

});



// //$(document).ready(function() {
//   $('#get-kits .element-to-slideInUp').css('opacity', 0);

//   if(window.matchMedia("(min-width: 769px)").matches) {
//     $('#get-kits .element-to-slideInUp').waypoint(function() {
//       $(this.element).addClass('slideInUp');
//       $(this.element).css('opacity', 1);
//     }, 
//     { offset: '95%' });
//   }

//   else {
//     $('#get-kits .element-to-slideInUp').waypoint(function() {
//       $(this.element).addClass('slideInUp');
//       $(this.element).css('opacity', 1);
//     }, 
//     { offset: '130%' });    
//   }
// //});



// //$(document).ready(function() {
//   $('#get-coaching .element-to-fadeInUp').css('opacity', 0);

//   if(window.matchMedia("(min-width: 769px)").matches) {
//     $('#get-coaching .element-to-fadeInUp').waypoint(function() {
//       $(this.element).addClass('fadeInUp');
//     }, 
//     { offset: '125%' });
//   }

//   else {
//     $('#get-coaching .element-to-fadeInUp').waypoint(function() {
//       $(this.element).addClass('fadeInUp');
//     }, 
//     { offset: '160%' });    
//   }
// //});



// //$(document).ready(function() {
//   $('#get-app .element-to-fadeInLeft').css('opacity', 0);

//   if(window.matchMedia("(min-width: 769px)").matches) {
//     $('#get-app .element-to-fadeInLeft').waypoint(function() {
//       $(this.element).addClass('fadeInLeft');
//     }, 
//     { offset: '95%' });
//   }

//   else {
//     $('#get-app .element-to-fadeInLeft').waypoint(function() {
//       $(this.element).addClass('fadeInLeft');
//     }, 
//     { offset: '130%' });    
//   }
// //});



// //$(document).ready(function() {
//   $('#get-app .element-to-fadeInRight').css('opacity', 0);

//   if(window.matchMedia("(min-width: 769px)").matches) {
//     $('#get-app .element-to-fadeInRight').waypoint(function() {
//       $(this.element).addClass('fadeInRight');
//     }, 
//     { offset: '95%' });
//   }

//   else {
//     $('#get-app .element-to-fadeInRight').waypoint(function() {
//       $(this.element).addClass('fadeInRight');
//     }, 
//     { offset: '130%' });    
//   }
// });
/*----------------------------------------------- GENERAL ANIMATE.CSS & WAYPOINT ANIMATIONS (END) -----------------------------------------------*/